import { notification } from "antd";
import { getDataFromS3 } from "../aws-amplify/storage";
import { http } from "./http";

const ROUTE_NAME = "RTM";

const Services = {
	getUserPolygons: async ({ onDownloadProgress, preferredId }) => {
		return http.get(`/${ROUTE_NAME}/getUserPolygons`, { onDownloadProgress, params: { preferredId } });
	},
	setInitialConfiguration: async () => {
		return http.post(`/${ROUTE_NAME}/setInitialConfiguration`);
	},
	applyFilter: async ({ Filters, selectedTypeIds, selectedType, filterData, sliderValue }) => {
		return http.post(`/${ROUTE_NAME}/applyFilter`, {
			Filters,
			selectedTypeIds,
			selectedType,
			filterData,
			sliderValue
		});
	},
	applyClientFilter: async ({ Filters, selectedTypeIds, selectedType, filterData, sliderValue }) => {
		return http.post(`/${ROUTE_NAME}/applyClientFilter`, {
			Filters,
			selectedTypeIds,
			selectedType,
			filterData,
			sliderValue
		});
	},
	getMinMax: async ({ _ApiTag }) => {
		return http.post(`/${ROUTE_NAME}/getMinMax`, { _ApiTag });
	},

	getFilteredShopIds: async ({ selectedTypeIds, Filters, selectedType, filterData, sliderValue }) => {
		return http.post(`/${ROUTE_NAME}/getFilteredShopIds`, {
			selectedTypeIds,
			Filters,
			selectedType,
			filterData,
			sliderValue
		});
	},
	getClientFilterIds: async ({ Filters, selectedTypeIds, selectedType, filterData, sliderValue }) => {
		return http.post(`/${ROUTE_NAME}/getClientFilterIds`, {
			Filters,
			selectedTypeIds,
			selectedType,
			filterData,
			sliderValue
		});
	},

	fetchCensusCount: async ({ type }) => {
		return http.get(`/${ROUTE_NAME}/fetchCensusCount`, { params: { type } });
	},

	fetchOutletCount: async ({ type, Filters }) => {
		return http.get(`/${ROUTE_NAME}/fetchOutletsCount`, {
			params: { type, filters: JSON.stringify(Filters || {}) }
		});
	},

	uploadExcelFile: async ({ file }) => {
		return http.post(
			`/convert/upload`,

			file,
			{
				headers: {
					"Content-Type": "multipart/form-data"
				}
			}
		);
	},
	dumpShops: async ({ tenant, data, config }) => {
		return http.post(`/${ROUTE_NAME}/dumpClient`, { tenant, data, config });
	},

	saveFilter: async (state, title, sliderValue) => {
		const { data } = await http.post(`/${ROUTE_NAME}/saveFilter`, {
			filters: state,
			sliderValue: sliderValue,
			title: title
		});

		return data;
	},

	updateFilter: async (filters, _id, sliderValue) => {
		const { data } = await http.post(`/${ROUTE_NAME}/updateFilter`, {
			filters,
			sliderValue,
			_id
		});
		return data;
	},

	deleteFilter: async ({ _id }) => {
		const { data } = await http.post(`/${ROUTE_NAME}/deleteFilter`, {
			_id
		});
		return data;
	},
	getCurrentUserFilters: async () => {
		const { data } = await http.get(`/${ROUTE_NAME}/getUserFilters`);
		return data;
	},

	fetchResponse: async (responseId, question) => {
		try {
			return http.get(`/${ROUTE_NAME}/response/${responseId}/getShopImage`, {
				params: { populate_survey: true, question }
			});
		} catch (err) {
			notification.error({
				message: "Error",
				description: "Error while fetching image"
			});
		}
	},

	fetchCensusShopsOfPolygon: async ({ params, source, onDownloadProgress }) => {
		return http.post(
			`/${ROUTE_NAME}/fetchCensusShopsOfPolygon`,
			{ ...params },
			{ cancelToken: source?.token, onDownloadProgress }
		);
	},

	fetchClientShopsOfPolygon: async ({ params, source, onDownloadProgress }) => {
		return http.post(
			`/${ROUTE_NAME}/fetchClientShopsOfPolygon`,
			{ ...params },
			{ cancelToken: source?.token, onDownloadProgress }
		);
	},

	fetchALLClientShops: async ({ source, onDownloadProgress }) => {
		return http.post(`/${ROUTE_NAME}/fetchALLClientShops`, {}, { cancelToken: source.token, onDownloadProgress });
	},

	downloadReport: async ({
		Filters,
		targetKeys,
		selectedTypeIds,
		onDownloadProgress,
		cancelToken,
		selectedType,
		filterData,
		sliderValue,
		email,
		emailReport
	}) => {
		return http.post(
			`/${ROUTE_NAME}/downloadRTMReport`,
			{ Filters, selectedTypeIds, targetKeys, selectedType, filterData, sliderValue, email, emailReport },
			{ responseType: "blob", onDownloadProgress, cancelToken }
		);
	},

	downloadRTMClientReport: async ({
		Filters,
		selectedTypeIds,
		onDownloadProgress,
		cancelToken,
		selectedType,
		targetKeys,
		filterData,
		sliderValue
	}) => {
		return http.post(
			`/${ROUTE_NAME}/downloadRTMClientReport`,
			{ selectedTypeIds, selectedType, targetKeys, Filters, filterData, sliderValue },
			{ responseType: "blob", onDownloadProgress, cancelToken }
		);
	},
	//initial Request Apis
	setCensusShopMarkersCache: async ({ types }) => {
		return http.post(`/${ROUTE_NAME}/setCensusShopMarkersCache`, { types });
	},

	setCensusShopDataCache: async ({ types }) => {
		return http.post(`/${ROUTE_NAME}/setCensusShopDataCache`, { types });
	},

	//Api to be Updated

	pushShopsToApp: async (filter_id, selectedDistributors, selectedRoutes) => {
		const { data } = await http.post(`/${ROUTE_NAME}/routes/pushToApp`, {
			filter_id,
			selectedDistributors,
			selectedRoutes
		});
		return data;
	},
	PullShopsFromApp: async (filter_id, selectedDistributors, selectedRoutes) => {
		const { data } = await http.post(`/${ROUTE_NAME}/routes/PullShopsFromApp`, {
			filter_id,
			selectedDistributors,
			selectedRoutes
		});
		return data;
	},

	fetchDataFromS3: async (tenant, geo, fileName) => {
		try {
			let key = `data/${tenant}/${geo}/${fileName}.json`;
			return getDataFromS3(key);
		} catch (error) {
			console.error(error);
		}
	},
	pushCensusShops: async ({ selectedTypeIds, Filters, selectedType, filterData }) => {
		try {
			return http.post(`/${ROUTE_NAME}/pushCensusShops`, { selectedTypeIds, Filters, selectedType, filterData });
		} catch (err) {
			return err;
		}
	},
	pullCensusShops: async ({ selectedTypeIds, Filters, selectedType, filterData }) => {
		try {
			return http.post(`/${ROUTE_NAME}/pullCensusShops`, { selectedTypeIds, Filters, selectedType, filterData });
		} catch (err) {
			return err;
		}
	},
	clearCache: async () => {
		return http.post(`/${ROUTE_NAME}/clearCache`);
	},
	fetchEcommerceDataFromS3: async () => {
		try {
			let key = `data/BAT_SWITZERLAND/ecommerce_data.json`;
			return getDataFromS3(key);
		} catch (error) {
			console.error(error);
		}
	},
	getUserPolygonsOfArea: async ({ areaType }) => {
		return http.get(`/${ROUTE_NAME}/getUserPolygonsOfArea`, {
			params: { areaType }
		});
	}
};
export default Services;
